import type { Assureur, Garant } from '../@types/Company';

const FNAIM_SERVICES_ORDER = ['Syndic de copropriété', 'Administrateur de biens', 'Transaction Vente Achat', 'Location habitation'];

/** Legal representatives listed in the FNAIM directory ("Représentants légaux" glued as "DupontJeanMartinClaire"). */
export const parseRepresentatives = (fnaimAdditionalInfo: string): string[] => {
  try {
    const info = JSON.parse(fnaimAdditionalInfo.replaceAll('\'', '"'));
    if (!info['Représentants légaux']) {return [];}

    // Split the string on the pattern of lowercase followed by uppercase
    return info['Représentants légaux']
      .split(/(?<=[a-z])(?=[A-Z])/)
      .map((name: string) => name.trim())
      .filter((name: string) => name.length > 0);
  } catch (e) {
    console.error('Error parsing representatives :', e);
    return [];
  }
};

export const parseGarants = (garantsJson: string): Garant[] => {
  try {
    return JSON.parse(garantsJson);
  } catch (e) {
    console.error('Error parsing garants :', e);
    return [];
  }
};

export const parseAssureurs = (assureursJson: string): Assureur[] => {
  try {
    return JSON.parse(assureursJson);
  } catch (e) {
    console.error('Error parsing assureurs :', e);
    return [];
  }
};

/** FNAIM services, stored as a Python-like list ("['Syndic de copropriété', ...]"), in business order. */
export const parseFnaimServices = (fnaimServices: string): string[] => {
  let services: string[];
  try {
    // Clean the string before parsing
    services = JSON.parse(fnaimServices
      .replaceAll('\'', '"')
      .replaceAll(/\s+/g, ' ')
      .trim());
  } catch (e) {
    console.error('Error parsing FNAIM services :', e);
    // If parsing fails, try to extract content between brackets
    const match = fnaimServices.match(/\[(.*)\]/);
    services = match
      ? match[1].split(',').map((service) => service.trim().replaceAll(/['"]/g, ''))
      : [fnaimServices]; // Return array with raw string if all parsing fails
  }

  return [...services].sort((a: string, b: string) => {
    const indexA = FNAIM_SERVICES_ORDER.indexOf(a);
    const indexB = FNAIM_SERVICES_ORDER.indexOf(b);

    // If both services are not in the order list, sort alphabetically
    if (indexA === -1 && indexB === -1) {
      return a.localeCompare(b);
    }

    // If one service is not in the order list, put it after
    if (indexA === -1) {return 1;}
    if (indexB === -1) {return -1;}

    // If both services are in the order list, use their order
    return indexA - indexB;
  });
};
